<div class="card">
   <div class="panel-head">
      <h3>Tasks</h3>
      <div class="spacer"></div>
   </div>

   <div
      class="section-loader"
      *ngIf="isLoading; else content">
      <div class="simple-spinner"></div>
   </div>

   <ng-template #content>
      <div
         *ngIf="!pastDueTasks.length && !upcomingTasks.length"
         class="empty-hint">
         No tasks for this hospital in the selected quarter.
      </div>

      <div
         class="acc-row"
         [class.open]="pastDueOpen"
         (click)="pastDueOpen = !pastDueOpen">
         <span class="acc-plus">{{ pastDueOpen ? "−" : "+" }}</span>
         <b>Past Due</b>
         <span class="cnt-pill red">{{ pastDueTasks.length }}</span>
      </div>
      <div
         class="acc-body"
         [class.open]="pastDueOpen">
         <label
            class="task"
            *ngFor="let task of pastDueTasks">
            <span>
               <span
                  class="t"
                  (click)="$event.preventDefault(); $event.stopPropagation(); openTask.emit(task.taskId)">
                  {{ task.title }}
               </span>
               <span class="m">
                  Due {{ task.dueDate | date: "MMM d" }} &middot; {{ task.assignedTo }} &middot;
                  <span class="tag goal">{{ task.goalName }}</span>
               </span>
            </span>
         </label>
      </div>

      <div
         class="acc-row"
         [class.open]="upcomingOpen"
         (click)="upcomingOpen = !upcomingOpen">
         <span class="acc-plus">{{ upcomingOpen ? "−" : "+" }}</span>
         <b>Upcoming Tasks</b>
         <span class="cnt-pill amber">{{ upcomingTasks.length }}</span>
      </div>
      <div
         class="acc-body"
         [class.open]="upcomingOpen">
         <label
            class="task"
            *ngFor="let task of upcomingTasks">
            <span>
               <span
                  class="t"
                  (click)="$event.preventDefault(); $event.stopPropagation(); openTask.emit(task.taskId)">
                  {{ task.title }}
               </span>
               <span class="m">
                  Due {{ task.dueDate | date: "MMM d" }} &middot; {{ task.assignedTo }} &middot;
                  <span class="tag goal">{{ task.goalName }}</span>
               </span>
            </span>
         </label>
      </div>

      <div
         class="addtask"
         *ngIf="!readOnly"
         (click)="onAddTask()">
         + Add a task
      </div>
   </ng-template>
</div>
